
// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { FiMenu, FiX, FiChevronDown, FiChevronUp } from "react-icons/fi";
// import logo from '../../Images/favicon.jpg';

// const Navbar = () => {
//   const [showMobileMenu, setShowMobileMenu] = useState(false);
//   const [showServiceDropdown, setShowServiceDropdown] = useState(false);
//   const [showAboutDropdown, setShowAboutDropdown] = useState(false);
//   const [isServiceHovered, setIsServiceHovered] = useState(false);
//   const [isAboutHovered, setIsAboutHovered] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   // Handle scroll effect
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 20);
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Prevent body scroll when mobile menu is open
//   useEffect(() => {
//     if (showMobileMenu) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [showMobileMenu]);

//   const serviceLinks = [
//     { name: "Gangavathi Service", path: "/gangavathi" },
//     { name: "Danapur Service", path: "/danapurwf" },
//     { name: "Kurekuppa Service", path: "/kurekuppawf" },
//     { name: "Raichur Service", path: "/raichurwf" },
//     { name: "Ballari Service", path: "/ballariwf" },
//   ];

//   const aboutLinks = [
//     { name: "JANATHA GROUP", path: "/about" },
//     { name: "JAW RANE", path: "/jaw-rane" },
//     { name: "JAW TEL TURBO", path: "/jaw-telturbo" },
//     { name: "JAW WABCO", path: "/jaw-wabco" },
//     { name: "JANATHA AUTOMOTIVES BATTERIES", path: "/jaw-tata-batteries" },
//     { name: "JANATHA ENTERPRISES CUMMINS", path: "/jaw-cummins" },
//     { name: "JAW ENGINE RECONDITIONING WORKS ", path: "/jaw-eng-recondition" },
//     { name: "JAW MINIGNG OPERATIONS", path: "/jaw-mining-operations" },
//     { name: "IQRA SCHOOL", path: "/jaw-iqra-school" },
//   ];

//   const navLinks = [
//     { name: "Home", path: "/" },
//     { name: "Products", path: "/mhcv" },
//     { name: "Services", path: null, dropdown: true, links: serviceLinks },
//     { name: "About Us", path: null, dropdown: true, links: aboutLinks },
//     { name: "Career", path: "/career" },
//     { name: "Blogs", path: "/blogs" },
//   ];

//   return (
//     <nav
//       className={`fixed w-full top-0 z-50 transition-all duration-300 ${
//         scrolled
//           ? "bg-white/95 backdrop-blur-md shadow-lg"
//           : "bg-white shadow-md"
//       }`}
//     >
//       <div className="container mx-auto px-4 sm:px-6 ">
//         <div className="flex justify-between items-center h-16 sm:h-20">
//           {/* Logo Section */}
//           <motion.a
//             href="/"
//             className="flex items-center gap-2 sm:gap-3 flex-shrink-0"
//             whileHover={{ scale: 1.02 }}
//             transition={{ duration: 0.2 }}
//           >
//             <img
//               src={logo}
//               alt="Janatha Automobiles Logo"
//               className="h-12 w-12 sm:h-14 sm:w-14 lg:h-16 lg:w-16 object-contain rounded-lg"
//             />
//             <div className="flex gap-4">
//               <span className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold bg-gradient-to-r from-blue-700 via-blue-800 to-blue-900 bg-clip-text text-transparent leading-tight">
//                 JANATHA AUTOMOBILES PVT LTD
//               </span>
//               {/* <span className="text-xs sm:text-sm lg:text-base font-semibold text-blue-600 leading-tight">
//                 PVT LTD
//               </span> */}
//             </div>
//           </motion.a>

//           {/* Desktop Navigation */}
//           <div className="hidden lg:flex items-center space-x-1 ">
//             {navLinks.map((link, index) =>
//               link.dropdown ? (
//                 <motion.div
//                   key={index}
//                   className="relative group"
//                   onMouseEnter={() => {
//                     if (link.name === "Services") setIsServiceHovered(true);
//                     if (link.name === "About Us") setIsAboutHovered(true);
//                   }}
//                   onMouseLeave={() => {
//                     if (link.name === "Services") setIsServiceHovered(false);
//                     if (link.name === "About Us") setIsAboutHovered(false);
//                   }}
//                 >
//                   <button className="bg-transparent flex items-center gap-1 px-3 xl:px-4 py-2 text-sm xl:text-base font-medium text-gray-700 hover:text-blue-700 transition-all duration-200 rounded-lg hover:bg-blue-50">
//                     {link.name}
//                     <FiChevronDown
//                       className={`w-4 h-4 transition-transform duration-200 ${
//                         (link.name === "Services" && isServiceHovered) ||
//                         (link.name === "About Us" && isAboutHovered)
//                           ? "rotate-180"
//                           : ""
//                       }`}
//                     />
//                   </button>

//                   <AnimatePresence>
//                     {((link.name === "Services" && isServiceHovered) ||
//                       (link.name === "About Us" && isAboutHovered)) && (
//                       <motion.div
//                         initial={{ opacity: 0, y: 10, scale: 0.95 }}
//                         animate={{ opacity: 1, y: 0, scale: 1 }}
//                         exit={{ opacity: 0, y: 10, scale: 0.95 }}
//                         transition={{ duration: 0.2 }}
//                         className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden"
//                       >
//                         <div className="py-2">
//                           {link.links.map((subLink, idx) => (
//                             <motion.a
//                               key={idx}
//                               href={subLink.path}
//                               className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-150 border-b border-gray-50 last:border-0"
//                               whileHover={{ x: 5 }}
//                             >
//                               {subLink.name}
//                             </motion.a>
//                           ))}
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </motion.div>
//               ) : (
//                 <motion.a
//                   key={index}
//                   href={link.path}
//                   className="relative px-3 xl:px-4 py-2 text-sm xl:text-base font-medium text-gray-700 hover:text-blue-700 transition-all duration-200 rounded-lg hover:bg-blue-50 group"
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                 >
//                   {link.name}
//                   <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-blue-700 transition-all duration-200 group-hover:w-3/4" />
//                 </motion.a>
//               )
//             )}
//             <motion.a
//               href="#contact"
//               className="ml-2 xl:ml-4 px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm xl:text-base font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200"
//               whileHover={{ scale: 1.05, y: -2 }}
//               whileTap={{ scale: 0.95 }}
//             >
//               Contact Us
//             </motion.a>
//           </div>

//           {/* Mobile Menu Button */}
//           <motion.button
//             onClick={() => setShowMobileMenu(!showMobileMenu)}
//             className="lg:hidden relative z-50 p-2 rounded-lg bg-blue-700 text-white hover:bg-blue-800 transition-colors duration-200 shadow-md"
//             whileTap={{ scale: 0.9 }}
//           >
//             {showMobileMenu ? (
//               <FiX className="w-6 h-6" />
//             ) : (
//               <FiMenu className="w-6 h-6" />
//             )}
//           </motion.button>
//         </div>

//         {/* Mobile Menu */}
//         <AnimatePresence>
//           {showMobileMenu && (
//             <>
//               {/* Backdrop */}
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 transition={{ duration: 0.2 }}
//                 className="lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
//                 onClick={() => setShowMobileMenu(false)}
//               />

//               {/* Menu Panel */}
//               <motion.div
//                 initial={{ x: "100%" }}
//                 animate={{ x: 0 }}
//                 exit={{ x: "100%" }}
//                 transition={{ type: "spring", damping: 25, stiffness: 200 }}
//                 className="lg:hidden fixed top-0 right-0 bottom-0 w-80 max-w-[85vw] bg-white shadow-2xl z-50 overflow-y-auto"
//               >
//                 <div className="p-6">
//                   {/* Menu Header */}
//                   <div className="flex justify-between items-center mb-8 pb-4 border-b border-gray-200">
//                     <span className="text-xl font-bold bg-gradient-to-r from-blue-700 to-blue-900 bg-clip-text text-transparent">
//                       Menu
//                     </span>
//                     <motion.button
//                       onClick={() => setShowMobileMenu(false)}
//                       className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
//                       whileTap={{ scale: 0.9 }}
//                     >
//                       <FiX className="w-5 h-5 text-gray-700" />
//                     </motion.button>
//                   </div>

//                   {/* Menu Items */}
//                   <div className="space-y-2">
//                     {navLinks.map((link, index) => (
//                       <React.Fragment key={index}>
//                         {link.dropdown ? (
//                           <div className="space-y-1">
//                             <motion.button
//                               onClick={() => {
//                                 if (link.name === "Services") {
//                                   setShowServiceDropdown(!showServiceDropdown);
//                                 } else if (link.name === "About Us") {
//                                   setShowAboutDropdown(!showAboutDropdown);
//                                 }
//                               }}
//                               className="w-full flex justify-between items-center p-3 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-800 font-medium transition-all duration-200"
//                               whileTap={{ scale: 0.98 }}
//                             >
//                               <span>{link.name}</span>
//                               <motion.div
//                                 animate={{
//                                   rotate:
//                                     (link.name === "Services" &&
//                                       showServiceDropdown) ||
//                                     (link.name === "About Us" &&
//                                       showAboutDropdown)
//                                       ? 180
//                                       : 0,
//                                 }}
//                                 transition={{ duration: 0.2 }}
//                               >
//                                 <FiChevronDown className="w-5 h-5" />
//                               </motion.div>
//                             </motion.button>

//                             <AnimatePresence>
//                               {((link.name === "Services" &&
//                                 showServiceDropdown) ||
//                                 (link.name === "About Us" &&
//                                   showAboutDropdown)) && (
//                                 <motion.div
//                                   initial={{ height: 0, opacity: 0 }}
//                                   animate={{ height: "auto", opacity: 1 }}
//                                   exit={{ height: 0, opacity: 0 }}
//                                   transition={{ duration: 0.2 }}
//                                   className="overflow-hidden"
//                                 >
//                                   <div className="pl-3 pr-3 pt-2 space-y-1">
//                                     {link.links.map((subLink, idx) => (
//                                       <motion.a
//                                         key={idx}
//                                         href={subLink.path}
//                                         className="block p-3 text-sm text-gray-700 rounded-lg hover:bg-blue-50 hover:text-blue-700 transition-all duration-150 border-l-2 border-transparent hover:border-blue-700"
//                                         onClick={() => setShowMobileMenu(false)}
//                                         whileHover={{ x: 5 }}
//                                         whileTap={{ scale: 0.98 }}
//                                       >
//                                         {subLink.name}
//                                       </motion.a>
//                                     ))}
//                                   </div>
//                                 </motion.div>
//                               )}
//                             </AnimatePresence>
//                           </div>
//                         ) : (
//                           <motion.a
//                             href={link.path}
//                             className="block p-3 text-gray-800 font-medium rounded-lg hover:bg-blue-50 hover:text-blue-700 transition-all duration-200"
//                             onClick={() => setShowMobileMenu(false)}
//                             whileHover={{ x: 5 }}
//                             whileTap={{ scale: 0.98 }}
//                           >
//                             {link.name}
//                           </motion.a>
//                         )}
//                       </React.Fragment>
//                     ))}

//                     {/* Contact Button */}
//                     <motion.a
//                       href="#contact"
//                       className="block mt-6 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200"
//                       onClick={() => setShowMobileMenu(false)}
//                       whileTap={{ scale: 0.95 }}
//                     >
//                       Contact Us
//                     </motion.a>
//                   </div>
//                 </div>
//               </motion.div>
//             </>
//           )}
//         </AnimatePresence>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import logo from '../../Images/favicon.jpg';

const Navbar = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [isServiceHovered, setIsServiceHovered] = useState(false);
  const [isAboutHovered, setIsAboutHovered] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showMobileMenu ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [showMobileMenu]);

  const serviceLinks = [
    { name: "Gangavathi Service", path: "/gangavathi" },
    { name: "Danapur Service", path: "/danapurwf" },
    { name: "Kurekuppa Service", path: "/kurekuppawf" },
    { name: "Raichur Service", path: "/raichurwf" },
    { name: "Ballari Service", path: "/ballariwf" },
  ];
  const aboutLinks = [
    { name: "JANATHA GROUP", path: "/about" },
    { name: "JAW RANE", path: "/jaw-rane" },
    { name: "JAW TEL TURBO", path: "/jaw-telturbo" },
    { name: "JAW WABCO", path: "/jaw-wabco" },
    { name: "JANATHA AUTOMOTIVES BATTERIES", path: "/jaw-tata-batteries" },
    { name: "JANATHA ENTERPRISES CUMMINS", path: "/jaw-cummins" },
    { name: "JAW ENGINE RECONDITIONING WORKS ", path: "/jaw-eng-recondition" },
    { name: "JAW MINIGNG OPERATIONS", path: "/jaw-mining-operations" },
    { name: "IQRA SCHOOL", path: "/jaw-iqra-school" },
  ];
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Products", path: "/mhcv" },
    { name: "Services", path: null, dropdown: true, links: serviceLinks },
    { name: "About Us", path: null, dropdown: true, links: aboutLinks },
    { name: "Career", path: "/career" },
    { name: "Blogs", path: "/blogs" },
  ];

  return (
    <nav className={`fixed w-full top-0 z-50 pointer-events-auto transition-all duration-300 ${
        scrolled
          ? "bg-white/95 shadow-lg"
          : "bg-white shadow-md"
      }`}
    >
      {/* ----------- FIX: Remove .container and use paddings on w-full div ----------- */}
      <div className="w-full h-full md:block px-4 sm:px-6">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <motion.a
            href="/"
            className="flex items-center gap-2 sm:gap-3 flex-shrink-0"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <img
              src={logo}
              alt="Janatha Automobiles Logo"
              className="h-12 w-12 sm:h-14 sm:w-14 lg:h-16 lg:w-16 object-contain rounded-lg"
            />
            <div className="flex gap-4">
              <span className="text-sm sm:text-base lg:text-xl xl:text-2xl font-bold bg-gradient-to-r from-blue-700 via-blue-800 to-blue-900 bg-clip-text text-transparent leading-tight">
                JANATHA AUTOMOBILES PVT LTD
              </span>
            </div>
          </motion.a>

          <div className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link, index) =>
              link.dropdown ? (
                <motion.div
                  key={index}
                  className="relative group"
                  onMouseEnter={() => {
                    if (link.name === "Services") setIsServiceHovered(true);
                    if (link.name === "About Us") setIsAboutHovered(true);
                  }}
                  onMouseLeave={() => {
                    if (link.name === "Services") setIsServiceHovered(false);
                    if (link.name === "About Us") setIsAboutHovered(false);
                  }}
                >
                  <button className="bg-transparent flex items-center gap-1 px-3 xl:px-4 py-2 text-sm xl:text-base font-medium text-gray-700 hover:text-blue-700 transition-all duration-200 rounded-lg hover:bg-blue-50">
                    {link.name}
                    <FiChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                        (link.name === "Services" && isServiceHovered) ||
                        (link.name === "About Us" && isAboutHovered)
                          ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence>
                    {((link.name === "Services" && isServiceHovered) ||
                      (link.name === "About Us" && isAboutHovered)) && (
                      <motion.div
                        initial={{ opacity: 0, y: 10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-[9999]"
                      >
                        <div className="py-2">
                          {link.links.map((subLink, idx) => (
                            <motion.a
                              key={idx}
                              href={subLink.path}
                              className="block px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-150 border-b border-gray-50 last:border-0"
                              whileHover={{ x: 5 }}
                            >
                              {subLink.name}
                            </motion.a>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              ) : (
                <motion.a
                  key={index}
                  href={link.path}
                  className="relative px-3 xl:px-4 py-2 text-sm xl:text-base font-medium text-gray-700 hover:text-blue-700 transition-all duration-200 rounded-lg hover:bg-blue-50 group"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {link.name}
                  <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-0.5 bg-blue-700 transition-all duration-200 group-hover:w-3/4" />
                </motion.a>
              )
            )}
            <motion.a
              href="#contact"
              className="ml-2 xl:ml-4 px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm xl:text-base font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              Contact Us
            </motion.a>
          </div>

          <motion.button
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            className="lg:hidden relative z-[9999] p-2 rounded-lg bg-blue-700 text-white hover:bg-blue-800 transition-colors duration-200 shadow-md"
            whileTap={{ scale: 0.9 }}
          >
            {showMobileMenu ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
          </motion.button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {showMobileMenu && (
            <>
              {/* Backdrop */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-[9998]"
                onClick={() => setShowMobileMenu(false)}
              />
              {/* Menu Panel */}
              <motion.div
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ type: "spring", damping: 25, stiffness: 200 }}
                className="lg:hidden fixed top-0 right-0 bottom-0 w-80 max-w-[85vw] bg-white shadow-2xl z-[9999] overflow-y-auto"
              >
                <div className="p-6">
                  {/* Menu Header */}
                  <div className="flex justify-between items-center mb-8 pb-4 border-b border-gray-200">
                    <span className="text-xl font-bold bg-gradient-to-r from-blue-700 to-blue-900 bg-clip-text text-transparent">Menu</span>
                    <motion.button
                      onClick={() => setShowMobileMenu(false)}
                      className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
                      whileTap={{ scale: 0.9 }}
                    >
                      <FiX className="w-5 h-5 text-gray-700" />
                    </motion.button>
                  </div>
                  <div className="space-y-2">
                    {navLinks.map((link, index) => (
                      <React.Fragment key={index}>
                        {link.dropdown ? (
                          <div className="space-y-1">
                            <motion.button
                              onClick={() => {
                                if (link.name === "Services") {
                                  setShowServiceDropdown(!showServiceDropdown);
                                } else if (link.name === "About Us") {
                                  setShowAboutDropdown(!showAboutDropdown);
                                }
                              }}
                              className="w-full flex justify-between items-center p-3 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-800 font-medium transition-all duration-200"
                              whileTap={{ scale: 0.98 }}
                            >
                              <span>{link.name}</span>
                              <motion.div
                                animate={{
                                  rotate:
                                    (link.name === "Services" && showServiceDropdown) ||
                                    (link.name === "About Us" && showAboutDropdown)
                                      ? 180 : 0,
                                }}
                                transition={{ duration: 0.2 }}
                              >
                                <FiChevronDown className="w-5 h-5" />
                              </motion.div>
                            </motion.button>
                            <AnimatePresence>
                              {((link.name === "Services" && showServiceDropdown) ||
                                (link.name === "About Us" && showAboutDropdown)) && (
                                  <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.2 }}
                                    className="overflow-hidden"
                                  >
                                    <div className="pl-3 pr-3 pt-2 space-y-1">
                                      {link.links.map((subLink, idx) => (
                                        <motion.a
                                          key={idx}
                                          href={subLink.path}
                                          className="block p-3 text-sm text-gray-700 rounded-lg hover:bg-blue-50 hover:text-blue-700 transition-all duration-150 border-l-2 border-transparent hover:border-blue-700"
                                          onClick={() => setShowMobileMenu(false)}
                                          whileHover={{ x: 5 }}
                                          whileTap={{ scale: 0.98 }}
                                        >
                                          {subLink.name}
                                        </motion.a>
                                      ))}
                                    </div>
                                  </motion.div>
                                )}
                            </AnimatePresence>
                          </div>
                        ) : (
                          <motion.a
                            href={link.path}
                            className="block p-3 text-gray-800 font-medium rounded-lg hover:bg-blue-50 hover:text-blue-700 transition-all duration-200"
                            onClick={() => setShowMobileMenu(false)}
                            whileHover={{ x: 5 }}
                            whileTap={{ scale: 0.98 }}
                          >
                            {link.name}
                          </motion.a>
                        )}
                      </React.Fragment>
                    ))}
                    {/* Contact Button */}
                    <motion.a
                      href="#contact"
                      className="block mt-6 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200"
                      onClick={() => setShowMobileMenu(false)}
                      whileTap={{ scale: 0.95 }}
                    >
                      Contact Us
                    </motion.a>
                  </div>
                </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;
